import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import SubNav from "./Subnav";

const SubMenu = ({ item, setSideBar, ...props }) => {
  const [subnav, setSubnav] = useState(false);
  let history = useHistory();
  const showSubNav = () => {
    if (item.subNav) {
      setSubnav(!subnav);
    } else {
      if (props.sideBar) {
        setSideBar(false);
      }
    }
  };
  return (
    <>
      <div
        className={`SidebarLink ${
          history.location.pathname === item.path ? "selected-nav-item" : ""
        }`}
      >
        {item?.subNav ? (
          <div
            onClick={() => {
              showSubNav();
            }}
            className="d-flex align-items-center w-100"
          >
            <div className="AnchorContent">
              {item?.image ? <img src={item?.image} /> : <>{item?.icon}</>}
              <div className="SidebarLabel">{item.title}</div>
            </div>
            <div className="SubnavIcon">
              {item.subNav && subnav
                ? item.iconOpened
                : item.subNav
                ? item.iconClosed
                : null}
            </div>
          </div>
        ) : (
          <Link className="d-flex text-white" to={item.path}>
            {item?.image ? <img src={item?.image} /> : <>{item?.icon}</>}
            <div className="SidebarLabel">{item.title}</div>
          </Link>
        )}
      </div>
      {/* This is where the sub-navigation menu goes */}
      {subnav &&
        item?.subNav?.map((subItem, index) => {
          return (
            <SubNav
              setSideBar={setSideBar}
              subItem={subItem}
              key={index}
              {...props}
            />
          );
        })}
    </>
  );
};

export default SubMenu;
